// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "2bd00ea4b168a2bbe770a180c95bf1351a3f06918807cdc3d56a4d494355b7cb" + ".css";
};